import styled from "styled-components";
import {getTheme} from "../../shared/themeUtils";

const Margin = styled.div`
    color: ${getTheme("colors.internal")};
    font-size: ${getTheme("fontSizes.xSmall")};
`

export default function InternalPriceMargin({absMargin, percentage, className, color}: {
  absMargin: number,
  percentage: string,
  color?: string,
  className?: string
}) {
  return (
    <Margin className={className} style={{color: color ? color : ""}}>
      {absMargin ? `M${absMargin}` : ""}
      {percentage ? `/${percentage.replace("%", "P")}` : ""}
    </Margin>
  )
}